const PALETTE_SIZE = 8;

/**
 * A stable color for an avatar's initials background, derived from whatever
 * name seeded it — the same person always lands on the same color, and two
 * people who happen to share a name land on the same color too, which is an
 * acceptable trade-off for a purely decorative hash (not an identity signal).
 *
 * Colors are read from `--avatar-palette-{n}` custom properties (defined in
 * `tokens.css`, with their own light/dark values, since `Avatar` is a
 * shared component with no module of its own) rather than hard-coded hex
 * here, so the palette can be retuned in one place.
 */
export function avatarColorFor(seed: string): { background: string; foreground: string } {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  const index = (hash % PALETTE_SIZE) + 1;
  return {
    background: `var(--avatar-palette-${index})`,
    foreground: `var(--avatar-palette-${index}-fg)`,
  };
}
